import {
  Component, ChangeDetectionStrategy, Output, EventEmitter, Input, ChangeDetectorRef, DestroyRef, inject, AfterViewInit, ElementRef, DOCUMENT,
} from '@angular/core'
import { HeaderSearchIntl } from './header-search.intl'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { IconComponent } from '@knorr-bremse-portals/ngx-components/components/icon'
import { InputComponent } from '@knorr-bremse-portals/ngx-components/components/controls/input'
import { FormsModule } from '@angular/forms'

import {
  iconSearch, iconClose,
} from '@knorr-bremse-portals/icons'

const clientScript = function (hostElement: HTMLElement) {
  const formElement = hostElement.querySelector('.form')

  hostElement.querySelector('[action--hide]')?.addEventListener('click', () => {
    formElement?.classList.remove('mobile-visible')
  })
  hostElement.querySelector('[action--show]')?.addEventListener('click', () => {
    formElement?.classList.add('mobile-visible')
  })
}

@Component({
  selector: 'kb-header-search',
  templateUrl: './header-search.component.html',
  styleUrls: ['./header-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [InputComponent, IconComponent, FormsModule],
})
export class HeaderSearchComponent implements AfterViewInit {
  protected iconSearch = iconSearch
  protected iconOpenSearch = iconSearch
  protected iconCloseSearch = iconClose

  @Input() public name = 'query'
  @Input() public query?: string
  @Output() public readonly queryChange = new EventEmitter<string>()
  @Output() public readonly ngSubmit = new EventEmitter<string>()

  private destroyRef = inject(DestroyRef)
  private cdr = inject(ChangeDetectorRef)
  protected intl = inject(HeaderSearchIntl)
  private hostElement = inject<ElementRef<HTMLElement>>(ElementRef)
  private document = inject(DOCUMENT)

  public constructor() {
    this.intl.changes$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => this.cdr.markForCheck())
  }

  public ngAfterViewInit(): void {
    clientScript(this.hostElement.nativeElement)
    this.setupClientScript()
  }

  private setupClientScript(): void {
    if (this.document.getElementById('header-search-client-script') !== null) {
      return
    }

    const scriptElement = this.document.createElement('script')
    scriptElement.id = 'header-search-client-script'

    const getHostElement = function () {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      return document.querySelector<HTMLElement>('kb-header-search')!
    }

    scriptElement.innerHTML = `(${clientScript.toString()})((${getHostElement.toString()})())`

    this.document.body.appendChild(scriptElement)
  }

  protected onSubmit(event: Event): void {
    event.preventDefault()
    this.ngSubmit.emit(this.query)
  }

  protected onQueryChange(query: string): void {
    this.query = query
    this.queryChange.emit(this.query)
  }
}
